import {
    Component,
    type OnInit,
    inject,
    ChangeDetectionStrategy,
} from "@angular/core";
import { FooterComponent } from "@coreui/angular";
import { DATA_QAA, dataQaaPrefix } from "@firm360/libs/observability/data-qaa";
import { AccountService, type IUser } from "../../../core";
import {
    Feature,
    FeatureService,
} from "../../../shared/feature/feature.service";

@Component({
    selector: "app-default-footer",
    templateUrl: "./default-footer.component.html",
    styleUrls: ["./default-footer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    hostDirectives: [DATA_QAA],
})
export class DefaultFooterComponent extends FooterComponent implements OnInit {
    private accountService = inject(AccountService);
    featureService = inject(FeatureService);

    protected readonly qaaPrefix = dataQaaPrefix(DefaultFooterComponent);

    currentAccount: IUser;
    year = new Date().getFullYear();
    ngOnInit(): void {
        this.accountService.identity().then((account) => {
            this.currentAccount = account;
        });
    }

    protected readonly Feature = Feature;
}
